// Keeps the phone's pairing on the device rather than in memory. Losing it means
// asking for a setup code that was already used, which puts the phone out of action
// until someone issues a new one.
//
// In a plugin rather than the composable because the saving has to last as long as
// the app is open, not only while one component happens to exist.
export default defineNuxtPlugin(() => {
  const device = useScanDevice()

  try {
    const stored = localStorage.getItem(SCAN_DEVICE_STORAGE_KEY)

    if (stored) {
      // Merged onto the defaults rather than trusted wholesale, keeping an older
      // stored shape from leaving a field undefined after an app update.
      device.value = { ...emptyScanDevice(), ...JSON.parse(stored) }

      // A phone paired before pairings were tracked, adopting what the database upgrade
      // stamps its records with. Here rather than on a session load, which needs the
      // server: a phone updating with no signal must keep its own scans.
      if (device.value.provisioned && !device.value.pairingId) {
        device.value.pairingId = LEGACY_PAIRING
      }
    }
  } catch {
    // Unreadable storage is treated as a phone that has not been set up. Better
    // than refusing to start.
    device.value = emptyScanDevice()
  }

  watch(device, (value) => {
    try {
      localStorage.setItem(SCAN_DEVICE_STORAGE_KEY, JSON.stringify(value))
    } catch {
      // Storage full or blocked. The app keeps working for this session, and the
      // maintenance screen is where a phone in that state gets noticed.
    }
  }, { deep: true })
})
